import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import AppointmentScheduler from "../../app/appointment/AppointmentScheduler";
import AppConfig from "../../core/service/AppConfig";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";

export default function AppointmentSchedulerPage()
{
    const {t} = useTranslation();

    useEffect(() => {
        document.title = `${t('Appointments')} | ${AppConfig.getRisTitle()}`;
    }, []);

    return (
        <LayoutWithSider fullWidth={true}>
            <AppointmentScheduler />
        </LayoutWithSider>
    )
}
